import React from 'react';
import { Box, Button } from '@mui/material';
import { useAuth, useSchool } from 'daymap-react';
import { useRouteError, isRouteErrorResponse, useNavigate, useLocation  } from 'react-router-dom';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';


const ErrorBoundary: React.FC = () => {    
  const error = useRouteError();
  console.log(error);
  const {SignOut} = useAuth();
  const {ClearSchool} = useSchool();
  const { reset } = useQueryErrorResetBoundary();
  const navigate = useNavigate();
  const location = useLocation();


  return (
    <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh', // To take up the full viewport height
        }}
      >
        <div>
            <h1>Oops - Something went wrong</h1>
            <h2>Please try the following</h2>
            <ul>
                <li>Click the browser "Back" button to return to the previous page.</li>
                <li>Returning to the login screen and trying again.</li>
                <li>Make sure your browser accepts cookies and try again.</li>
                <li>If you suspect authorisation is the problem as the school to grant you access</li>
            </ul>
            <Button onClick={() => {reset();navigate(location.pathname + location.search, { replace: true });}}>Try Again</Button>
            <Button onClick={() => {SignOut(); ClearSchool();}}>Sign Out</Button>
            <br/>
            If you continue to experience this error please contact your school's administrator and include the details below.
            <h2>Additional technical details</h2>
            <strong>Error Message: </strong>{isRouteErrorResponse(error) ? error.data?.message : hasMessage(error) ? error.message : "Unknown error occured"}<br/>
            <strong>Date and Time: </strong>{new Date().toLocaleString()}
        </div>
    </Box>
  );
};

function hasMessage(error: unknown): error is { message: string } {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as any).message === "string"
  );
}

export {ErrorBoundary};